import { Box, styled, Theme } from '@mui/material';
import { ReleaseSongStatus } from 'services/api/entities/distribution/release';

export const StatusContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
});

const getStatusColor = (theme: Theme, status: ReleaseSongStatus) => {
  switch (status) {
    case ReleaseSongStatus.VALID:
      return theme.palette.success.light;
    case ReleaseSongStatus.WARNING:
      return theme.palette.warning.light;
    default:
      return theme.palette.error.light;
  }
};

export const StatusCircle = styled(Box)<{ status: ReleaseSongStatus }>(
  ({ theme, status }) => ({
    borderRadius: '50%',
    width: theme.spacing(1),
    height: theme.spacing(1),
    backgroundColor: getStatusColor(theme, status),
  })
);
